var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('top'),_c('div',{staticClass:"mian",style:({ height: _vm.mianH + 'px' })},[_c('left'),_c('div',{attrs:{"id":"novel_main"}},[_c('novelSuccess',{attrs:{"type":_vm.type,"successNovelId":_vm.successNovelId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }